import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivityStep } from '@models/activity.model';
import { NavigationMenuButtonItem } from '@models/menu-button.model';
import { ActivityStateService } from '@services/activity/state/activity-state.service';
import { MenuButtonComponent } from '@shared-components/menu-button/menu-button.component';
import { ProgressStepperBadgeComponent } from '@shared-components/progress-stepper-badge/progress-stepper-badge.component';
import { Subscription } from 'rxjs';
import { DomSanitizerPipe, ProgressSpinnerComponent } from 'tangoe-design-system';

@Component({
  selector: 'ts-progress-bar',
  templateUrl: './progress-bar.component.html',
  imports: [
    CommonModule,
    ProgressStepperBadgeComponent,
    MenuButtonComponent,
    ProgressSpinnerComponent,
    DomSanitizerPipe
  ]
})
export class ProgressBarComponent implements OnInit, OnDestroy {
  steps: ActivityStep[] = [];
  active_step_index: number = -1;
  private subscriptions: Subscription = new Subscription();

  constructor(private activity_state_svc: ActivityStateService, private router: Router) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.activity_state_svc.steps_subject.subscribe((steps: ActivityStep[]) => {
        this.steps = steps;
        this.active_step_index = this.activity_state_svc.activeStepIndex();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  progressSpinnerLabel(): string {
    if (this.active_step_index < 0 || !this.steps.length) return '';
    return `${this.active_step_index + 1} of ${this.steps.length}`;
  }

  progressSpinnerProgress(): number {
    if (this.active_step_index < 0 || !this.steps.length) return 0;
    return ((this.active_step_index + 1) / this.steps.length) * 100;
  }

  navigationLinks(): NavigationMenuButtonItem[] {
    return this.steps.reduce((acc, config) => {
      if (config.can_navigate_to && config.step_url)
        acc.push({ label: config.step_name, href: config.step_url });
      return acc;
    }, [] as NavigationMenuButtonItem[]);
  }

  navigateToStep(url: string): void {
    this.router.navigateByUrl(url);
  }
}
